export enum CustomerAccess {
  Backup = 0,
  Migration = 1
}
